import { z } from "zod";

export const InquiryReason = z.enum(["info", "visita", "documenti", "offerta", "altro"]);

export const InquiryInput = z.object({
  reason: InquiryReason,
  name: z.string().min(2).max(120),
  email: z.string().email(),
  phone: z.string().max(40).optional(),
  lang: z.enum(["it", "en", "de"]).default("it"),
  message: z.string().min(5).max(4000),
  listing_id: z.string().uuid().optional(),
  consents: z.object({
    privacy: z.literal(true),
    marketing: z.boolean().default(false),
  }),
  utm: z.record(z.string()).optional(),
  turnstile_token: z.string().min(10),
});
export type InquiryInput = z.infer<typeof InquiryInput>;
